import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import '@/assets/css/global.scss'
import vuetify from './plugins/vuetify'
import '@babel/polyfill'
import '@/plugins/moment'
import '@/plugins/axios'
import '@/plugins/infintyloading'
import '@/plugins/sweetAlert' // Importar SweetAlert2
import '@/plugins/firebasePlugin' // Importar Firebase como plugin global
// import '@/plugins/ckeditor' // Comentado temporalmente para permitir la compilación

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
